import {HTTP} from "../../../libs/HTTP"
import mediaApi from "../../media/api/MediaApi";
import MediaFileInfo from "../../media/model/MediaFileInfo";
import NotesCount from "../model/NotesCount";

class NotesApi {
    uriPrefix = "/api/notes";

    getNotes(filter, page) {
        var params = {...filter, page}
        return HTTP.get(this.uriPrefix, {
            params: params
        })
        .then(response => response.data)
    }
    createNote(data){
        return HTTP.post(this.uriPrefix, data)
            .then(response => response.data)
    }

    updateNote(data){
        return HTTP.put(this.uriPrefix, data)
            .then(response => response.data)
    }
    
    getNote(id) {
        return HTTP.get(this.uriPrefix + `/${id}`)
            .then(response => response.data)
    }

    deleteNote(id) {
        return HTTP.delete(this.uriPrefix + `/${id}`)
            .then(response => response.data)
    }

    deleteNotFile(noteId, fileId) {
        return HTTP.delete(this.uriPrefix + `/${noteId}/file/${fileId}`)
            .then(response => response.data)
    }

    getNoteFiles(noteId) {
        return HTTP.get(this.uriPrefix + `/${noteId}/files`)
            .then(response => {
                return response.data.map(it => {
                    let c = new MediaFileInfo()
                    c.id = it.id;
                    c.contentType = it.contentType;
                    c.ext = it.ext;
                    c.name = it.name;
                    c.size = it.size;
                    return c
                })
            })
    }

    uploadNoteFile(noteId, file) {
        var url = `${this.uriPrefix}/${noteId}/files`
        return mediaApi.uploadFile(url, file)
    }

    setNoteFavorites(noteId, favorites) {
        return HTTP.put(this.uriPrefix + `/favorites`, {
            id: noteId,
            favorites: favorites
        })
        .then(response => response.data)
    }

    getNotesCount() {
        return HTTP.get(this.uriPrefix + `/count`)
        .then(response => response.data)
        // .then(response => response.data.map(it => {
        //     return new NotesCount(it.categoryId, it.count);
        // }))
    }
}
const notesApi =  new NotesApi();
export default notesApi;